'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('../utils/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendStyle(style, extension) {
  // extend conditional style objects
  if (extension.hasOwnProperty('condition')) {
    if (extension.condition) {
      (0, _assign2.default)(style, extend(extension.style));
    }
  } else {
    // extend basic style objects
    (0, _assign2.default)(style, extension);
  }
} /*  weak */


function extend(style) {
  Object.keys(style).forEach(function (property) {
    var value = style[property];
    if (property === 'extend') {
      // arrayify to loop each extension to support arrays and single extends
      [].concat(value).forEach(function (extension) {
        return extendStyle(style, extension);
      });
      delete style[property];
    } else if (value instanceof Object && !Array.isArray(value)) {
      // support nested extend as well
      style[property] = extend(value);
    }
  });

  return style;
}

exports.default = function () {
  return extend;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/plugins/extend.js
// module id = 475
// module chunks = 0